import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Dropdown,
  Breadcrumb,
} from "react-bootstrap";

import { FiHome, FiUpload, FiPlus, FiChevronUp } from "react-icons/fi";
import SLAPoliciesList from "../../../components/super-admin/Subscription/Tickets/SLAPoliciesList";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";

const SLAPoliciesPage = () => {
  const [show, setShow] = useState(false);

  const [policies, setPolicies] = useState([
    {
      priority: "Critical",
      description: "System wide outage affecting all tenants",
      first: "1 Hour",
      resolution: "2 – 4 Hours",
      escalation: "1 hour",
      escalatesTo: "Support Lead",
    },
    {
      priority: "High",
      description: "Core module failure affecting primary workflow",
      first: "4 Hours",
      resolution: "8 Hours",
      escalation: "2 hours",
      escalatesTo: "Support Lead",
    },
    {
      priority: "Medium",
      description: "Minor issue affecting a limited user group",
      first: "8 Hours",
      resolution: "24 Hours",
      escalation: "4 hours",
      escalatesTo: "Support Team",
    },
    {
      priority: "Low",
      description: "Low impact problem affecting few users",
      first: "24 Hours",
      resolution: "1 - 2 Days",
      escalation: "6 hours",
      escalatesTo: "Support Team",
    },
  ]);

  const [formData, setFormData] = useState({
    priority: "",
    description: "",
    first: "",
    resolution: "",
    escalation: "",
    escalatesTo: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    setPolicies([...policies, formData]);

    setFormData({
      priority: "",
      description: "",
      first: "",
      resolution: "",
      escalation: "",
      escalatesTo: "",
    });

    setShow(false);
  };

  return (
    <Container
      style={{ padding: "20px", background: "#f8f9fa", height: "100vh" }}
      fluid
      className="p-4  "
    >
      {/* Breadcrumb */}

      <Row className="align-items-center mb-3">
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              SLA Policies
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
              
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Tickets
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">SLA Policies</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
        {/* 
        <Col md={6}>

          <h3 className="mb-1">SLA Policies</h3>

          <div className="d-flex align-items-center text-muted">

            <FiHome />

            <span className="mx-2">Tickets</span>

            <span>SLA Policies</span>

          </div>

        </Col> */}

        <Col md={6} className="text-md-end">
          <Dropdown className="d-inline me-2">
            <Dropdown.Toggle className="border" variant="light">
              <FiUpload className="me-1" />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button
            style={{
              background: "#f26522",
            }}
            className="me-2 border-0"
            onClick={() => setShow(true)}
          >
            <FiPlus className="me-2" />
            Add New Policy
          </Button>

          <Button variant="light">
            <FiChevronUp />
          </Button>
        </Col>
      </Row>

      {/* Card */}

      {/* <Card>

        <Card.Header className="d-flex justify-content-between flex-wrap">

          <h5>SLA Policies List</h5>

          <div className="d-flex">

            <Dropdown className="me-2">

              <Dropdown.Toggle variant="light">
                Select Priority
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Critical</Dropdown.Item>
                <Dropdown.Item>High</Dropdown.Item>
                <Dropdown.Item>Medium</Dropdown.Item>
                <Dropdown.Item>Low</Dropdown.Item>
              </Dropdown.Menu>

            </Dropdown>

            <Dropdown>

              <Dropdown.Toggle variant="light">
                Sort By : Last 7 Days
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Recently Added</Dropdown.Item>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
                <Dropdown.Item>Last Month</Dropdown.Item>
                <Dropdown.Item>Last 7 Days</Dropdown.Item>
              </Dropdown.Menu>

            </Dropdown>

          </div>

        </Card.Header>

        <Card.Body className="p-0">

          <Table responsive hover className="mb-0">

            <thead className="table-light">

              <tr>

                <th>
                  <Form.Check />
                </th>

                <th>Priority</th>
                <th>Description</th>
                <th>First Response Time</th>
                <th>Resolution Time</th>
                <th>Escalation Time</th>
                <th>Escalates To</th>

              </tr>

            </thead>

            <tbody>

              {policies.map((item, index) => (

                <tr key={index}>

                  <td>
                    <Form.Check />
                  </td>

                  <td className="fw-semibold">
                    {item.priority}
                  </td>

                  <td>{item.description}</td>

                  <td>{item.first}</td>

                  <td>{item.resolution}</td>

                  <td>{item.escalation}</td>

                  <td>{item.escalatesTo}</td>

                </tr>

              ))}

            </tbody>

          </Table>

        </Card.Body>

      </Card> */}
      <SLAPoliciesList policies={policies} />

      {/* Modal */}

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Policy</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Policy</Form.Label>

              <Form.Control
                name="priority"
                value={formData.priority}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>

              <Form.Control
                as="textarea"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>First Response Time</Form.Label>

              <Form.Select name="first" onChange={handleChange}>
                <option>Select</option>
                <option>1 Hour</option>
                <option>4 Hours</option>
                <option>8 Hours</option>
                <option>24 Hours</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Resolution Time</Form.Label>

              <Form.Select name="resolution" onChange={handleChange}>
                <option>Select</option>
                <option>2 – 4 Hours</option>
                <option>8 Hours</option>
                <option>24 Hours</option>
                <option>1 - 2 Days</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Escalation Time</Form.Label>

              <Form.Select name="escalation" onChange={handleChange}>
                <option>Select</option>
                <option>1 hour</option>
                <option>2 hours</option>
                <option>4 hours</option>
                <option>6 hours</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Escalates To</Form.Label>

              <Form.Select name="escalatesTo" onChange={handleChange}>
                <option>Select</option>
                <option>Support Lead</option>
                <option>Support Team</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>

          <Button style={{ backgroundColor: "#f26522" }} onClick={handleSave}>
            Save Policy
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default SLAPoliciesPage;
